import 'core/assets/fonts/VTB Group UI/stylesheet.css';
import { css } from '@emotion/react';

// import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = () => {
  return css`
    :root {
      --white: #ffffff;
      --light: #efe9f4;
      --dark: #171d1c;
      --grey: #7e8287;
      --light-grey: #7e828740;
      --blue: #5fbff9;
      --neon-blue: #5863f8;
      --neon-blue-hover: #3063f8;
      --green: #16bac5;
    }

    html,
    body,
    #root {
      width: 100%;
      height: 100%;
    }

    body {
      background: #ffffff;
      color: #202124;
      margin: 0;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
        'Droid Sans', 'Helvetica Neue', sans-serif;
      font-family: 'VTBGroupUIWebBook', sans-serif;
      overflow: hidden;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    code {
      font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
    }

    [type='search'] {
      outline-offset: 0;
    }

    button {
      border: none;
      background: transparent;
      cursor: pointer;
      padding: 0;
    }

    a,
    button {
      font-family: 'VTBGroupUIWebBook', sans-serif !important;
    }

    .MuiButton-root {
      letter-spacing: initial !important;
      font-family: 'VTBGroupUIWebBook', sans-serif !important;
    }

    .MuiTypography-root {
      font-family: 'VTBGroupUIWebBook', sans-serif !important;
    }

    .page-wrapper {
      min-height: 100%;
    }

    .animateFadeIn {
      animation: FadeIn 0.2s ease-out both;
    }

    .animateFadeOut {
      animation: FadeOut 0.2s ease-out both;
    }

    @keyframes FadeIn {
      from {
        opacity: 0;
      }

      to {
        opacity: 1;
      }
    }

    @keyframes FadeOut {
      from {
        opacity: 1;
      }

      to {
        opacity: 0;
      }
    }

    .Toastify__toast-container {
      width: 500px;
    }

    .Toastify__toast-container .Toastify__toast-icon {
      align-self: flex-start;
    }

    .MuiDialog-paper {
      min-width: 900px;
    }

    .MuiModal-root {
      display: grid;
      align-items: center;
      justify-content: center;
    }

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-track {
      background-color: #e4e4e4;
      border-radius: 6px;
    }

    &::-webkit-scrollbar-thumb {
      border: 1px solid #e4e4e4;
      background-color: rgba(0, 0, 0, 0.3);
      border-radius: 6px;
    }

    .MuiSelect-select {
      &[class*='SizeSmall'] {
        padding: 10px 14px;
      }
    }

    svg.mic-vad {
      .vad-active {
        animation: micVad 4s infinite;
        transform: rotate(180deg);
        transform-origin: center;
      }
    }

    @keyframes micVad_ {
      0% {
        height: 0px;
      }
      6.25% {
        height: 10px;
      }
      12.5% {
        height: 2px;
      }
      18.75% {
        height: 8px;
      }
      25% {
        height: 4px;
      }
      31.25% {
        height: 22px;
      }
      37.5% {
        height: 16px;
      }
      43.75% {
        height: 8px;
      }
      50% {
        height: 0px;
      }
      56.25% {
        height: 10px;
      }
      62.5% {
        height: 2px;
      }
      68.75% {
        height: 8px;
      }
      75% {
        height: 4px;
      }
      81.25% {
        height: 22px;
      }
      87.5% {
        height: 16px;
      }
      93.75% {
        height: 8px;
      }
      100% {
        height: 0px;
      }
    }

    @keyframes micVad {
      0% {
        height: 0px;
      }
      12.5% {
        height: 20px;
      }
      25% {
        height: 0px;
      }
      37.5% {
        height: 20px;
      }
      50% {
        height: 0px;
      }
      62.5% {
        height: 20px;
      }
      75% {
        height: 0px;
      }
      87.5% {
        height: 18px;
      }
      100% {
        height: 0px;
      }
    }
  `;
};
